import { Node, Nodes } from "./types";
import { getLeaves } from "./checkbox-tree-item/utils";

/**
 * Обновляет список `disabled` нод.
 * Если родительская нода содержится в `disabledNodesList`, все её вложенные ноды также будут добавлены в результат.
 *
 * @param nodes - Исходный массив нод.
 * @param disabledNodesList - Список отключенных нод.
 * @returns Массив, содержащий значения `value` отключенных нод и их вложенных нод.
 */
export const completeDisabledNodesListWithNestedValues = (
  nodes: Nodes = [],
  disabledNodesList: string[] = []
) => {
  const updatedDisabledNodes: string[] = [];

  function traverseNodes(node: Node, isParentDisabled = false) {
    const isCurrentNodeDisabled = disabledNodesList.includes(node.value);
    const isChildParentDisabled = isParentDisabled || isCurrentNodeDisabled;

    if (isChildParentDisabled) {
      updatedDisabledNodes.push(node.value);
    }

    if (node.nodes) {
      const leavesList = getLeaves(node.nodes);

      const isAllLeavesDisabled = leavesList.every((value) =>
        disabledNodesList.includes(value)
      );

      if (isAllLeavesDisabled) {
        updatedDisabledNodes.push(node.value);
      }

      for (const childNode of node.nodes) {
        traverseNodes(childNode, isChildParentDisabled);
      }
    }
  }

  for (const node of nodes) {
    traverseNodes(node);
  }

  return updatedDisabledNodes;
};

/**
 * Добавляет в список отмеченные ноды и исключает ноды с которых было снято выделение.
 * Ноды из списка disabledList игнорируются.
 *
 * @param checked - Исходный массив отмеченных нод.
 * @param changed - Массив изменённых нод.
 * @param disabledList - Список disabled нод.
 * @param isChecked - Флаг, указывающий, является ли нода отмеченной.
 * @returns Новый массив отмеченных нод.
 */
export const updateCheckedNodes = (
  checked: string[],
  changed: string[],
  isChecked: boolean,
  disabledList: string[] = []
) => {
  let result: string[];

  if (isChecked) {
    result = checked.concat(
      changed.filter(
        (value) => !checked.includes(value) && !disabledList.includes(value)
      )
    );
  } else {
    result = checked.filter(
      (value) => !changed.includes(value) || disabledList.includes(value)
    );
  }

  return result;
};
